module.exports = __webpack_public_path__ + "files/472569191124a681943ffe6000d2da83.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-bold-webfont.woff
// module id = 656
// module chunks = 60